/**
 * Contains a set of known regular expressions.
 */
export abstract class Regex {
  /** Validate against numbers only. */
  public static readonly Numbers: RegExp = /^[0-9]*$/;

  /** Validate against the Saudi national identity number pattern. */
  public static readonly NationalId: RegExp = /^[1|2][0-9]{9}$/;

  /** Validate against the Saudi mobile number pattern. */
  public static readonly Mobile: RegExp = /^05[0-9]{8}$/;
}
